module.exports = __webpack_public_path__ + "img/gb6187.prt.64dad376.jpg";